import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams, ModalController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';
import { GeriBildirimEkleGuncellePage } from '../geri-bildirim-ekle-guncelle/geri-bildirim-ekle-guncelle';

/**
 * Generated class for the GeriBildirimPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-geri-bildirim',
  templateUrl: 'geri-bildirim.html',
})
export class GeriBildirimPage {

  firmaAdi = "";
  GeriBildirim: any = { ID: -1, Bildirim: "", FirmaAdi: "", BildirimDurumu: "", VerilenCevap: "" };
  BildirimListesi = [];

  constructor(public navCtrl: NavController,
    public ortak: Ortak,
    public modalCtrl:ModalController,
    public bllOrtak: BllOrtak,
    public navParams: NavParams) {

  }

  ionViewDidLoad() {
    this.FirmaGetir();

  }

  FirmaGetir() {
    this.bllOrtak.islemWithoutPost("FirmaBilgileri", "", false).then(a => {
      var sonuc = <any>a;
      this.firmaAdi = sonuc.SonucObject;
    
      if (this.firmaAdi.length > 0) {
        this.BildirimListesiFirma();
      }
      else {
        this.ortak.showBasicAlert("Hata", "Firma bilgilerinizi kontrol ediniz..")
      }
    }).catch(x => {
    })
  }

  BildirimListesiFirma() {
    var formData = new FormData();
    formData.append("FirmaAdi", this.firmaAdi);

    this.bllOrtak.geribildirim(formData, "GeriBildirimListeleFirma", "", true).then(a => {
      var sonuc = <any>a;
      this.BildirimListesi = sonuc.SonucObject;
  


    })
  }
  YeniEkle()
  {
    let modal = this.modalCtrl.create(GeriBildirimEkleGuncellePage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/geri-bildirim/geri-bildirim.ts